export interface LayoutModel {
  name: string;
  isCollapsed?: boolean;
}

export enum eLayoutType {
  application = 'application',
  account = 'account',
  empty = 'empty',
}